// angular
import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { ContactItemComponent } from './components/contact-item/contact-item.component';
// types & utils
import { ContactDialogItem } from './shared/contact-dialog-item.type';
import { DialogRef } from '@app/core/shared/utils/dialog/dialog-ref';
import { DIALOG_DATA } from '@app/core/shared/utils/dialog/dialog-tokens';

@Component({
  selector: 'pwj-contact-dialog',
  standalone: true,
  imports: [ContactItemComponent, TranslateModule],
  templateUrl: './contact-dialog.component.html',
  styleUrl: './contact-dialog.component.scss',
})
export class ContactDialogComponent {
  public title!: string;
  public contactsData!: ContactDialogItem[];

  // dependencies
  private readonly dialogRef = inject(DialogRef);
  public readonly data: {
    title: string;
    contactsData: ContactDialogItem[];
  } = inject(DIALOG_DATA);

  constructor() {
    // set dialog data
    this.title = this.data.title;
    this.contactsData = this.data.contactsData;
  }

  close() {
    this.dialogRef.close();
  }
}
